import React, { useEffect, RefObject, useState } from 'react';

export default function useArrayRef<T = any>(length: number) {
  const [elRefs, setElRefs] = useState<RefObject<T>[]>([]);

  useEffect(() => {
    setElRefs((old) =>
      Array(length)
        .fill(undefined)
        .map((_, i) => old[i] || React.createRef<T>()),
    );
  }, [length]);

  return elRefs;
}
